import React from 'react'
import { Card, Grid, Icon } from '@softwaredev_cegeka/stix-core'
import './unauthorizedCard.scss'

export default function UnauthorizedCard() {
    return (
        <Grid.Row>
            <Grid.Col md={{ offset: 4, span: 4 }}>
                <Card className={'unauthorized-card mt-5'}>
                    <Card.Body>
                        <Icon icon={'lock'} />
                        <div className={'unauthorized-content'}>
                            <Card.Title className={'unauthorized-title'}>
                                Unauthorized
                            </Card.Title>
                            <p>You are not authorized to access this data.</p>
                        </div>
                    </Card.Body>
                </Card>
            </Grid.Col>
        </Grid.Row>
    )
}
